import * as React from 'react';
import { useEffect, useState } from 'react';

import { ConnectedRootAdminUi } from '../../app/rootAdminUi/ConnectedRootAdminUi';
import { RootAdminUiState } from '../../app/rootAdminUi/RootAdminUIState';
import { RootSpaceRouter } from '../../app/spaces/RouterHelpers/RootSpaceRouter';
import { NavigationTelemetry } from '../../app/spaces/RouterHelpers/TelemetryRouter';

interface IAppAdminStateScope {
  displayDefault: boolean;
  displayInnerApp: boolean;
}

export type RootAppOwnProps = {
}

export type RootAppStateProps = {
  rootAdminUiState: RootAdminUiState;
}

export type RootAppProps = RootAppStateProps & RootAppOwnProps;

export function RootApp(props: RootAppProps): JSX.Element {
  // Note: using local state and effect to determine whicj child components to display since removing these seemingly extra state and effects seems 
  // to cause a lot of things to fail (odd UI screen displayed, integration test failures). My guess is it's a timing issue perhaps related to moving
  // away from angular while angualr is still being used in places. Craeting a story TFS 1281215 to come back to this component and try removing local 
  // state and effect and instead use props.rootAdminUiState directly to determine which child componets are displayed.
  const [adminStateScope, setAdminStateScope] = useState<IAppAdminStateScope>({
    displayDefault : false,
    displayInnerApp : false
});

  useEffect(() => {
    const newDisplayDefault: boolean =  props.rootAdminUiState === 'default';
    const newDisplayInnerApp: boolean = props.rootAdminUiState !== 'default' && props.rootAdminUiState !== 'bootstrap';
    if(adminStateScope.displayDefault !== newDisplayDefault || adminStateScope.displayInnerApp !== newDisplayInnerApp){
        setAdminStateScope({
          displayDefault : newDisplayDefault,
          displayInnerApp : newDisplayInnerApp
      });
      }
  }, [props.rootAdminUiState, adminStateScope.displayDefault, adminStateScope.displayInnerApp]);

  return (
      <div className="tb-app-inner">
          { adminStateScope.displayInnerApp ? <div><ConnectedRootAdminUi /></div> : null }
          { adminStateScope.displayDefault ? <div><RootSpaceRouter /></div> : null }
          { adminStateScope.displayDefault ? <div><NavigationTelemetry /></div> : null }
      </div>
    );
}